import { ChangeDetectorRef, Component,DestroyRef,inject,OnInit } from '@angular/core';
import { NavbarComponent } from '../../../components/layout/navbar/navbar.component';
import { RouterLink, RouterOutlet } from '@angular/router';
import { AccessibilityNavComponent } from '../../../components/layout/accessability-nav/accessibility-nav.component';
import { FooterComponent } from '../../../components/layout/footer/footer.component';
import { pageSeoInfo } from '../../../constants/page-seo-info';
import { SeoService } from '../../../services/seo.service';
import { CachingService } from '../../../services/caching.service';
import { distinctUntilChanged, skip } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-workshop',
  standalone: true,
  imports: [AccessibilityNavComponent,RouterOutlet,NavbarComponent,FooterComponent],
  templateUrl: './workshop.component.html',
  styleUrl: './workshop.component.scss'
})
export class WorkshopComponent implements OnInit {
  renderUniversityContent = true;
  private readonly destroyRef = inject(DestroyRef);

  constructor(private seoService: SeoService,
    private cachingService: CachingService,
    private cdr: ChangeDetectorRef,
  ) {

  }

  ngOnInit(): void {
    const { title, description, canonicalUrl } =
      pageSeoInfo['workshop'];
    this.seoService.setPageTitle(title);
    this.seoService.setPageDescription(description);
    this.seoService.setCanonicalUrl(canonicalUrl);
    this.subscribeToLanguageChange();
  }
   private subscribeToLanguageChange(): void {
      this.cachingService.languageChange$
        .pipe(
          skip(1),
          distinctUntilChanged(),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe(() => {
          this.refreshAppContent();
        });
    }
    private refreshAppContent(): void {
      this.renderUniversityContent = false;
      this.cdr.detectChanges();
      setTimeout(() => {
        this.renderUniversityContent = true;
        this.cdr.detectChanges();
      });
    }
}

